import script from "./EventSetupEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./EventSetupEdit.vue?vue&type=script&setup=true&lang=js"

import "./EventSetupEdit.vue?vue&type=style&index=0&id=27beac1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27beac1e"]])

export default __exports__